export const getStatusLabel = (status) => {
  const labels = {
    draft: 'Draft',
    open: 'Open',
    paid: 'Paid',
    uncollectible: 'Uncollectible',
    void: 'Void',
    upcoming: 'Upcoming',
    past_due: 'Past Due',
    active: 'Active',
    canceled: 'Canceled',
    incomplete: 'Incomplete',
    incomplete_expired: 'Incomplete Expired',
    trialing: 'Trialing',
    unpaid: 'Unpaid',
    paused: 'Paused',
  };
  return labels[status] || 'Unknown';
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'draft':
      return 'default';
    case 'open':
      return 'warning';
    case 'paid':
    case 'active':
      return 'success';
    case 'uncollectible':
      return 'error';
    case 'void':
      return 'secondary';
    case 'upcoming':
      return 'info';
    case 'past_due':
    case 'unpaid':
      return 'error';
    case 'canceled':
      return 'secondary';
    case 'incomplete':
    case 'incomplete_expired':
      return 'warning';
    case 'trialing':
      return 'info';
    case 'paused':
      return 'default';
    default:
      return 'default';
  }
};
